// Shared metadata + honesty-preserving badge logic for Budget Trackers.
export const FUND_META = {
  recording: { label: "Recording", color: "#35606E" },
  marketing: { label: "Marketing", color: "#B0703C" },
  advance: { label: "In-pocket advances", color: "#5C7A4A" },
  legal_outside_funds: { label: "Legal (outside funds)", color: "#7A5C8A" },
};

export const CORE_FUNDS = ["recording", "marketing", "advance"];

// A payment-status badge that NEVER claims bank receipt. "Paid" (AP) = submitted.
export function paymentBadge(t) {
  if (!t) return { label: "—", cls: "bg-neutral-100 text-neutral-600 border-neutral-200" };
  const ps0 = t.payment_status || "";
  if (/ap in review|approval unconfirmed/i.test(ps0))
    return { label: "AP review · approval unconfirmed", cls: "bg-amber-100 text-amber-900 border-amber-400", hint: ps0 };
  if (ps0.trimStart().startsWith("Conflict:"))
    return { label: "Conflict · payment unverified", cls: "bg-red-50 text-red-700 border-red-300", hint: ps0 };
  if (t.bookmarked || t.ap_group === "Bookmarked")
    return { label: "Bookmarked · planned", cls: "bg-indigo-50 text-indigo-700 border-indigo-200", hint: "Bookmarked / planned — not paid" };
  if (t.kind === "reported_payment")
    return { label: "Reported by email", cls: "bg-purple-50 text-purple-700 border-purple-200", hint: "Email-reported payment, not AP-matched" };
  const ps = t.payment_status || "";
  if (ps === "provider_email_receipt")
    return { label: "Email receipt", cls: "bg-sky-50 text-sky-700 border-sky-200", hint: "Provider email receipt on file" };
  const ag = t.ap_group;
  if (ag === "New Payment Requests")
    return { label: "Pending · Net 30", cls: "bg-amber-50 text-amber-700 border-amber-200", hint: "Net-30 payment pending processing" };
  if (ag === "Archives" || ps === "No Longer Applicable")
    return { label: ps === "No Longer Applicable" ? "N/A" : "Archived", cls: "bg-neutral-100 text-neutral-500 border-neutral-200" };
  if (ag === "Paid" || ps.includes("Submitted"))
    return { label: "Paid · submitted", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", hint: "AP Paid group = payment submitted, not bank-confirmed" };
  return { label: ps || "Pending", cls: "bg-neutral-100 text-neutral-600 border-neutral-200" };
}

// Colors for the committed-spend segments (paid / pending / bookmarked).
export const SPEND_SEGMENTS = [
  { key: "paid_cents", label: "Paid (submitted)", color: "#2E8B6F" },
  { key: "pending_cents", label: "Pending · Net 30", color: "#D9A441" },
  { key: "bookmarked_cents", label: "Bookmarked · planned", color: "#6B6FC9" },
];

export const pct = (spent, budget) => {
  if (!budget || budget <= 0 || spent == null) return 0;
  return Math.min(100, Math.round((spent / budget) * 100));
};
